import React from 'react';
import AppRoutes from './routes';
import { GlobalProvider } from './Context/GlobalState';
import GlobalLoader from './components/GlobalLoader';

function App() {
  return (
    <GlobalProvider>
      <GlobalLoader />
      <AppRoutes />
    </GlobalProvider>
  );
}

export default App;
